import { solidstate } from ":setup/qstate";
import { global } from ":shared/app";
import { createEffect, createMemo, Match, Switch } from "solid-js";

import { Loader2 } from ":src/components/loaders";
import { GradingModal, SubmissionsTable } from "./components";
import { teams, scoring } from "./apis";
import { createInput, createSelect } from ":ui/form";
import type { SubmissionStatus } from "./_model";

function getTitle() {
  const jwt = global.api.auth.token.decoded();
  if (jwt.user_key === "evaluator") {
    return "evaluation";
  }
  if (jwt.user_key === "judge") {
    return "judging";
  }
  if (jwt.user_key === "filterer") {
    return "nominees";
  }
  return "";
}
export default function () {
  const $details = solidstate.createAsync(teams.get);
  const title = getTitle();
  // const counts = createMemo(() => {
  //   const history_length = $details.value?.history?.length ?? 0;
  //   const teams_length = $details.value?.teams?.length ?? 0;

  //   return {
  //     total: teams_length,
  //     graded: history_length,
  //     ungraded: teams_length - history_length,
  //   };
  // });
  const $applied_filter = solidstate.create({} as { search?: string; status?: SubmissionStatus });
  const $filters = createMemo(() => {
    const result = {
      // search: ["title", "category"],
      statuses: ["pending", "done"] as SubmissionStatus[],
    };
    return result;
  });
  const Search = createInput(null);
  const FilterStatus = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const status = FilterStatus.control.value;
    $applied_filter.set((s) => ({ ...s, status: status }));
  });

  return (
    <section class="flex flex-col w-full h-full px-2 py-2">
      <h1 class="text-xl  font-600 text-black z-1 capitalize <sm:(text-22px)">{title}</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterStatus.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Status..."
          options={$filters().statuses}
          allowClearSelected
        />
      </div>
      <Switch>
        <Match when={$details.state.loading}>
          <Loader2 msg="Loading Submissions..." />
        </Match>
        <Match when={$details.state.failed}>error occured while loading membres {$details.error}</Match>
        <Match when={$details.state.success}>
          <SubmissionsTable
            details={$details.value}
            filter={{ search: $applied_filter.value.search, status: $applied_filter.value.status }}
            onEvaluate={({ item, itemIndex }) => {
              global.store.actions.popop.pushModal({
                title: "Evaluate Team",
                startExpanded: true,
                element(action) {
                  return (
                    <GradingModal
                      data={$details as any}
                      idx={itemIndex()}
                      onSubmit={({ team, scores }) => {
                        return scoring.postOrPut({ team, scores });
                      }}
                    />
                  );
                },
              });
            }}
          />
        </Match>
      </Switch>
    </section>
  );
}
